export enum FecJournalMappingStatus {
  Standard = 'standard',
  CustomJournal = 'custom_journal',
  CustomLabel = 'custom_label',
}
